var map = {
	"./background-hots-bg.jpg": 99687,
	"./background-main-website.jpg": 55188,
	"./css/common.css": 15450,
	"./gamemodes/ARAM.webp": 78283,
	"./gamemodes/chill.webp": 73404,
	"./gamemodes/smile.webp": 38422,
	"./gamemodes_page_background.jpg": 3169,
	"./general/HeroesOfTheStormRankedPlay.png": 62259,
	"./general/Janitor.webp": 87109,
	"./general/gameplay.jpg": 87,
	"./general_page_background.jpg": 93811,
	"./heroes_page_background - Copy.jpg": 79629,
	"./heroes_page_background.jpg": 32429,
	"./heroes_page_background.webp": 91534,
	"./heroes_portraits/abathur.png": 78323,
	"./heroes_portraits/abathur.webp": 2328,
	"./heroes_portraits/alarak.png": 78092,
	"./heroes_portraits/alarak.webp": 40641,
	"./heroes_portraits/alexstrasza.png": 64230,
	"./heroes_portraits/alexstrasza.webp": 66639,
	"./heroes_portraits/ana.png": 71738,
	"./heroes_portraits/ana.webp": 58539,
	"./heroes_portraits/anduin.png": 93163,
	"./heroes_portraits/anduin.webp": 40688,
	"./heroes_portraits/anubarak.png": 27643,
	"./heroes_portraits/anubarak.webp": 2496,
	"./heroes_portraits/artanis.png": 65194,
	"./heroes_portraits/artanis.webp": 7803,
	"./heroes_portraits/arthas.png": 59571,
	"./heroes_portraits/arthas.webp": 82104,
	"./heroes_portraits/auriel.png": 28512,
	"./heroes_portraits/auriel.webp": 83149,
	"./heroes_portraits/azmodan.png": 14966,
	"./heroes_portraits/azmodan.webp": 31039,
	"./heroes_portraits/blaze.png": 89260,
	"./heroes_portraits/blaze.webp": 76353,
	"./heroes_portraits/brightwing.png": 9435,
	"./heroes_portraits/brightwing.webp": 54464,
	"./heroes_portraits/cassia.png": 88162,
	"./heroes_portraits/cassia.webp": 36467,
	"./heroes_portraits/chen.png": 1098,
	"./heroes_portraits/chen.webp": 33883,
	"./heroes_portraits/cho.webp": 77825,
	"./heroes_portraits/chogall.png": 68,
	"./heroes_portraits/chromie.png": 64319,
	"./heroes_portraits/chromie.webp": 91804,
	"./heroes_portraits/deathwing.png": 50811,
	"./heroes_portraits/deathwing.webp": 9024,
	"./heroes_portraits/deckard.png": 69842,
	"./heroes_portraits/deckard.webp": 95171,
	"./heroes_portraits/dehaka.png": 7282,
	"./heroes_portraits/dehaka.webp": 70915,
	"./heroes_portraits/diablo.png": 79509,
	"./heroes_portraits/diablo.webp": 28102,
	"./heroes_portraits/dva.png": 18811,
	"./heroes_portraits/dva.webp": 97888,
	"./heroes_portraits/etc.png": 65578,
	"./heroes_portraits/etc.webp": 3323,
	"./heroes_portraits/falstad.png": 17963,
	"./heroes_portraits/falstad.webp": 62160,
	"./heroes_portraits/fenix.png": 11584,
	"./heroes_portraits/fenix.webp": 87565,
	"./heroes_portraits/gall.png": 9614,
	"./heroes_portraits/gall.webp": 80663,
	"./heroes_portraits/garrosh.png": 19362,
	"./heroes_portraits/garrosh.webp": 62867,
	"./heroes_portraits/gazlowe.png": 24425,
	"./heroes_portraits/gazlowe.webp": 25058,
	"./heroes_portraits/genji.png": 54597,
	"./heroes_portraits/genji.webp": 38582,
	"./heroes_portraits/greymane.png": 79246,
	"./heroes_portraits/greymane.webp": 12567,
	"./heroes_portraits/guldan.png": 68011,
	"./heroes_portraits/guldan.webp": 13616,
	"./heroes_portraits/hanzo.png": 34556,
	"./heroes_portraits/hanzo.webp": 28657,
	"./heroes_portraits/hogger.png": 23654,
	"./heroes_portraits/hogger.webp": 4559,
	"./heroes_portraits/illidan.png": 45403,
	"./heroes_portraits/illidan.webp": 51808,
	"./heroes_portraits/imperius.png": 30122,
	"./heroes_portraits/imperius.webp": 12027,
	"./heroes_portraits/jaina.png": 75963,
	"./heroes_portraits/jaina.webp": 50144,
	"./heroes_portraits/johanna.png": 44909,
	"./heroes_portraits/johanna.webp": 87998,
	"./heroes_portraits/junkrat.png": 23203,
	"./heroes_portraits/junkrat.webp": 95496,
	"./heroes_portraits/kaelthas.png": 95269,
	"./heroes_portraits/kaelthas.webp": 95958,
	"./heroes_portraits/kelthuzad.png": 27978,
	"./heroes_portraits/kelthuzad.webp": 68891,
	"./heroes_portraits/kerrigan.png": 2615,
	"./heroes_portraits/kerrigan.webp": 47892,
	"./heroes_portraits/kharazim.png": 63241,
	"./heroes_portraits/kharazim.webp": 27010,
	"./heroes_portraits/leoric.png": 46052,
	"./heroes_portraits/leoric.webp": 86553,
	"./heroes_portraits/lili.png": 12842,
	"./heroes_portraits/lili.webp": 99451,
	"./heroes_portraits/liming.png": 51084,
	"./heroes_portraits/liming.webp": 80353,
	"./heroes_portraits/lostvikings.png": 15075,
	"./heroes_portraits/lostvikings.webp": 46312,
	"./heroes_portraits/lt-morales.webp": 87953,
	"./heroes_portraits/ltmorales.png": 48173,
	"./heroes_portraits/lucio.png": 67564,
	"./heroes_portraits/lucio.webp": 10753,
	"./heroes_portraits/lunara.png": 46723,
	"./heroes_portraits/lunara.webp": 22024,
	"./heroes_portraits/maiev.png": 26002,
	"./heroes_portraits/maiev.webp": 98915,
	"./heroes_portraits/malfurion.png": 6545,
	"./heroes_portraits/malfurion.webp": 85226,
	"./heroes_portraits/malganis.png": 98362,
	"./heroes_portraits/malganis.webp": 85035,
	"./heroes_portraits/malthael.png": 87190,
	"./heroes_portraits/malthael.webp": 67007,
	"./heroes_portraits/medivh.png": 15091,
	"./heroes_portraits/medivh.webp": 63256,
	"./heroes_portraits/mei.png": 81647,
	"./heroes_portraits/mei.webp": 45132,
	"./heroes_portraits/mephisto.png": 78743,
	"./heroes_portraits/mephisto.webp": 40852,
	"./heroes_portraits/muradin.png": 82886,
	"./heroes_portraits/muradin.webp": 35439,
	"./heroes_portraits/murky.png": 91808,
	"./heroes_portraits/murky.webp": 2573,
	"./heroes_portraits/nazeebo.png": 9832,
	"./heroes_portraits/nazeebo.webp": 1013,
	"./heroes_portraits/nova.png": 9216,
	"./heroes_portraits/nova.webp": 82989,
	"./heroes_portraits/orphea.png": 62639,
	"./heroes_portraits/orphea.webp": 64172,
	"./heroes_portraits/probius.png": 15418,
	"./heroes_portraits/qhira.png": 64931,
	"./heroes_portraits/qhira.webp": 48776,
	"./heroes_portraits/ragnaros.png": 73237,
	"./heroes_portraits/ragnaros.webp": 71526,
	"./heroes_portraits/raynor.png": 89867,
	"./heroes_portraits/raynor.webp": 61072,
	"./heroes_portraits/rehgar.png": 72079,
	"./heroes_portraits/rehgar.webp": 26924,
	"./heroes_portraits/rexxar.png": 32976,
	"./heroes_portraits/rexxar.webp": 65117,
	"./heroes_portraits/samuro.png": 39249,
	"./heroes_portraits/samuro.webp": 31370,
	"./heroes_portraits/sgt-hammer.webp": 88828,
	"./heroes_portraits/sgthammer.png": 51856,
	"./heroes_portraits/sondius.webp": 99430,
	"./heroes_portraits/sonya.png": 6874,
	"./heroes_portraits/sonya.webp": 80619,
	"./heroes_portraits/stitches.png": 7157,
	"./heroes_portraits/stitches.webp": 39270,
	"./heroes_portraits/stukov.png": 8040,
	"./heroes_portraits/stukov.webp": 71253,
	"./heroes_portraits/sylvanas.png": 79849,
	"./heroes_portraits/sylvanas.webp": 57026,
	"./heroes_portraits/tassadar.png": 69523,
	"./heroes_portraits/tassadar.webp": 86680,
	"./heroes_portraits/thebutcher.png": 52704,
	"./heroes_portraits/thebutcher.webp": 5485,
	"./heroes_portraits/thrall.png": 18293,
	"./heroes_portraits/thrall.webp": 15110,
	"./heroes_portraits/tracer.png": 33537,
	"./heroes_portraits/tracer.webp": 44186,
	"./heroes_portraits/tychus.png": 25486,
	"./heroes_portraits/tychus.webp": 26327,
	"./heroes_portraits/tyrael.png": 85083,
	"./heroes_portraits/tyrael.webp": 54432,
	"./heroes_portraits/tyrande.png": 20509,
	"./heroes_portraits/tyrande.webp": 99598,
	"./heroes_portraits/uther.png": 3136,
	"./heroes_portraits/uther.webp": 97517,
	"./heroes_portraits/valeera.png": 44756,
	"./heroes_portraits/valeera.webp": 98761,
	"./heroes_portraits/valla.png": 65880,
	"./heroes_portraits/valla.webp": 88933,
	"./heroes_portraits/varian.png": 41491,
	"./heroes_portraits/varian.webp": 54360,
	"./heroes_portraits/whitemane.png": 34782,
	"./heroes_portraits/whitemane.webp": 51911,
	"./heroes_portraits/xul.png": 55811,
	"./heroes_portraits/xul.webp": 88200,
	"./heroes_portraits/yrel.png": 12004,
	"./heroes_portraits/yrel.webp": 45401,
	"./heroes_portraits/zagara.png": 57030,
	"./heroes_portraits/zagara.webp": 89551,
	"./heroes_portraits/zarya.png": 93165,
	"./heroes_portraits/zarya.webp": 67966,
	"./heroes_portraits/zeratul.png": 76095,
	"./heroes_portraits/zeratul.webp": 67644,
	"./heroes_portraits/zuljin.png": 96686,
	"./heroes_portraits/zuljin.webp": 43447,
	"./heroes_splash/Kael'thas_HotS_art.webp": 89447,
	"./heroes_splash/anduin.webp": 38641,
	"./heroes_splash/anubarak.webp": 27465,
	"./heroes_splash/artanis.webp": 3212,
	"./heroes_splash/auriel.webp": 50160,
	"./heroes_splash/blaze.webp": 63578,
	"./heroes_splash/brightwing.webp": 47293,
	"./heroes_splash/cassia.webp": 43678,
	"./heroes_splash/chromie.webp": 54547,
	"./heroes_splash/deckard.webp": 24424,
	"./heroes_splash/dehaka.webp": 99298,
	"./heroes_splash/etc.webp": 95104,
	"./heroes_splash/falstad.webp": 26435,
	"./heroes_splash/garrosh.webp": 96744,
	"./heroes_splash/gazlowe.webp": 83177,
	"./heroes_splash/genji.webp": 61897,
	"./heroes_splash/greymane.webp": 36466,
	"./heroes_splash/guldan.webp": 99173,
	"./heroes_splash/jaina.webp": 32339,
	"./heroes_splash/johanna.webp": 35633,
	"./heroes_splash/junkrat.webp": 45931,
	"./heroes_splash/kaelthas.webp": 59767,
	"./heroes_splash/li-ming.webp": 75465,
	"./heroes_splash/lili.webp": 29630,
	"./heroes_splash/lt-morales.webp": 25724,
	"./heroes_splash/lucio.webp": 39182,
	"./heroes_splash/lunara.webp": 6697,
	"./heroes_splash/malthael.webp": 20994,
	"./heroes_splash/muradin.webp": 91800,
	"./heroes_splash/qhira.webp": 31703,
	"./heroes_splash/raynor.webp": 34369,
	"./heroes_splash/rehgar.webp": 90313,
	"./heroes_splash/rexxar.webp": 5936,
	"./heroes_splash/sgt-hammer.webp": 11553,
	"./heroes_splash/sonya.webp": 65364,
	"./heroes_splash/thrall.webp": 65319,
	"./heroes_splash/tychus.webp": 1974,
	"./heroes_splash/valla.webp": 47534,
	"./heroes_splash/xul.webp": 8543,
	"./logo.png": 33153,
	"./mainpage/Probius_Emblem_Portrait.webp": 28081,
	"./mainpage/about_me.webp": 66644,
	"./mainpage/gamemodes.webp": 46642,
	"./mainpage/general.webp": 91056,
	"./mainpage/heroes.webp": 70044,
	"./mainpage/maps.webp": 68679,
	"./maps/dragon-shire/globe_1.jpg": 36391,
	"./maps/infernal-shrines/globe_1.jpg": 73246,
	"./maps/infernal-shrines/globe_2.jpg": 46953,
	"./maps/menu/alterac-banner.png": 69319,
	"./maps/menu/blackhearts-banner.png": 4317,
	"./maps/menu/boe-banner.png": 70165,
	"./maps/menu/braxis-banner.png": 41076,
	"./maps/menu/cursed-banner.png": 704,
	"./maps/menu/dragon-shire-banner.png": 6628,
	"./maps/menu/garden-banner.png": 99924,
	"./maps/menu/hanamura-banner.png": 99424,
	"./maps/menu/haunted-mines-banner.png": 48971,
	"./maps/menu/shrines-banner.png": 31979,
	"./maps/menu/sky-temple-banner.png": 14104,
	"./maps/menu/spider-banner.png": 80432,
	"./maps/menu/towers-of-doom-banner.png": 53327,
	"./maps/menu/volskaya-banner.png": 7513,
	"./maps/menu/warhead-banner.png": 17035,
	"./maps/towers-of-doom/globe_1.jpg": 40238,
	"./maps/towers-of-doom/globe_2.jpg": 96377,
	"./maps/towers-of-doom/globe_3.jpg": 99004,
	"./maps_page_background.jpg": 51332,
	"./nav/logo_hots.png": 4800,
	"./roles/all.png": 15069,
	"./roles/bruiser.png": 15228,
	"./roles/healer.png": 59441,
	"./roles/melee-assassin.png": 6380,
	"./roles/ranged-assassin.png": 95933,
	"./roles/support.png": 79781,
	"./roles/tank.png": 48362,
	"./talents/abathur/abathur_carapace.png": 51458,
	"./talents/abathur/abathur_evolvemonstrosity.png": 13892,
	"./talents/abathur/abathur_locustnest.png": 9360,
	"./talents/abathur/abathur_spawnlocust.png": 25389,
	"./talents/abathur/abathur_spikeburst.png": 83164,
	"./talents/abathur/abathur_stab.png": 8620,
	"./talents/abathur/abathur_symbiote.png": 93864,
	"./talents/abathur/abathur_toxicnest.png": 37541,
	"./talents/abathur/abathur_ultimateevolution.png": 10158,
	"./talents/abathur/abathur_volatilemutation.png": 96449,
	"./talents/abathur/talent_mule.png": 35602,
	"./talents/alarak/alarak_counterstrike.png": 28594,
	"./talents/alarak/alarak_discordstrike.png": 52158,
	"./talents/alarak/alarak_hastybargain.png": 37475,
	"./talents/alarak/alarak_lasttrick.png": 67793,
	"./talents/alarak/alarak_lightningsurge.png": 33030,
	"./talents/alarak/alarak_recklesscharge.png": 42312,
	"./talents/alarak/alarak_sadism.png": 21975,
	"./talents/alarak/alarak_sadism_a.png": 32760,
	"./talents/alarak/alarak_sadism_b.png": 56880,
	"./talents/alarak/alarak_telekinesis.png": 81126,
	"./talents/alarak/alarak_telekinesis_a.png": 47522,
	"./talents/alarak/talent_autoattack_cooldown.png": 30603,
	"./talents/alexstrasza/alexstrasza_abundance.png": 88631,
	"./talents/alexstrasza/alexstrasza_blessing_of_the_red.png": 23735,
	"./talents/alexstrasza/alexstrasza_cleansing_flame.png": 52264,
	"./talents/alexstrasza/alexstrasza_dragon_queen.png": 35682,
	"./talents/alexstrasza/alexstrasza_dragon_queen_a.png": 32070,
	"./talents/alexstrasza/alexstrasza_dragon_scales.png": 4319,
	"./talents/alexstrasza/alexstrasza_exuberance.png": 10714,
	"./talents/alexstrasza/alexstrasza_flame_buffet.png": 17944,
	"./talents/alexstrasza/alexstrasza_gift_of_life.png": 2807,
	"./talents/alexstrasza/alexstrasza_life_binder.png": 34675,
	"./talents/alexstrasza/alexstrasza_life_blossom.png": 6800,
	"./talents/alexstrasza/alexstrasza_life_unbound.png": 74860,
	"./talents/alexstrasza/alexstrasza_pacify.png": 20006,
	"./talents/ana/ana_aim_down_sights.png": 10365,
	"./talents/ana/ana_aim_down_sights_a.png": 60277,
	"./talents/ana/ana_biotic_grenade.png": 47961,
	"./talents/ana/ana_debilitatingdart.png": 30585,
	"./talents/ana/ana_healing_dart.png": 28646,
	"./talents/ana/ana_healing_dart_a.png": 86914,
	"./talents/ana/ana_healing_dart_b.png": 43001,
	"./talents/ana/ana_nano_boost.png": 96910,
	"./talents/ana/ana_overwatch.png": 54621,
	"./talents/ana/ana_shrike.png": 70230,
	"./talents/ana/ana_sleep_dart.png": 79831,
	"./talents/anduin/anduin_blessed_recovery.png": 92852,
	"./talents/anduin/anduin_chastise.png": 95568,
	"./talents/anduin/anduin_chastise_a.png": 40696,
	"./talents/anduin/anduin_desperate_prayer.png": 72139,
	"./talents/anduin/anduin_divine_star.png": 73382,
	"./talents/anduin/anduin_flash_heal.png": 74639,
	"./talents/anduin/anduin_holy_word_salvation.png": 80771,
	"./talents/anduin/anduin_inner_focus.png": 19891,
	"./talents/anduin/anduin_leap_of_faith.png": 78541,
	"./talents/anduin/anduin_light_bomb.png": 75347,
	"./talents/anduin/anduin_lightwell.png": 25150,
	"./talents/anduin/anduin_varians_legacy.png": 36902,
	"./talents/anubarak/anubarak_burrowcharge.png": 54477,
	"./talents/anubarak/anubarak_combo_q_e.png": 62292,
	"./talents/anubarak/anubarak_hardencarapace_var1.png": 17521,
	"./talents/anubarak/anubarak_impale.png": 17314,
	"./talents/anubarak/anubarak_locustswarm.png": 50176,
	"./talents/anubarak/anubarak_scarabhost.png": 73624,
	"./talents/anubarak/anubarak_webblast.png": 58140,
	"./talents/anubarak/draft_portrait_anubarak.png": 92993,
	"./talents/anubarak/talent_autoattack_damage.png": 4174,
	"./talents/anubarak/talent_burningrage.png": 2787,
	"./talents/anubarak/talent_regenerationmaster.png": 18038,
	"./talents/anubarak/talent_rewind.png": 36532,
	"./talents/artanis/artanis_disruptionweb.png": 62129,
	"./talents/artanis/artanis_doubleslash_on.png": 32686,
	"./talents/artanis/artanis_doubleslash_var1.png": 95649,
	"./talents/artanis/artanis_powerstrikes.png": 61584,
	"./talents/artanis/artanis_purifierbeam.png": 15949,
	"./talents/artanis/artanis_repositionmatrix.png": 51669,
	"./talents/artanis/artanis_shieldoverload.png": 37473,
	"./talents/artanis/artanis_shieldoverload_a.png": 71297,
	"./talents/artanis/talent_autoattack_damage.png": 27725,
	"./talents/artanis/talent_autoattack_slow.png": 36837,
	"./talents/arthas/antimagicshell.png": 13455,
	"./talents/arthas/arthas_armyofthedead.png": 34197,
	"./talents/arthas/arthas_deathcoil.png": 13717,
	"./talents/arthas/arthas_frostmournehungers_off.png": 51466,
	"./talents/arthas/arthas_frozentempest.png": 14190,
	"./talents/arthas/arthas_frozentempest_a.png": 52922,
	"./talents/arthas/arthas_howlingblast.png": 14240,
	"./talents/arthas/arthas_runetap.png": 3053,
	"./talents/arthas/arthas_summonsindragosa.png": 87198,
	"./talents/arthas/talent_block.png": 60002,
	"./talents/arthas/talent_icebound_fortitude.png": 87023,
	"./talents/auriel/auriel_angelicflight.png": 34509,
	"./talents/auriel/auriel_angelicsweep.png": 15511,
	"./talents/auriel/auriel_angelicsweep_b.png": 30576,
	"./talents/auriel/auriel_bestowhope.png": 73192,
	"./talents/auriel/auriel_bestowhope_a.png": 12000,
	"./talents/auriel/auriel_rayofheaven.png": 27934,
	"./talents/auriel/auriel_restrainingblow.png": 7992,
	"./talents/auriel/auriel_restrainingblow_a.png": 17424,
	"./talents/auriel/auriel_resurrect.png": 30433,
	"./talents/auriel/auriel_ribboncocoon.png": 28653,
	"./talents/auriel/auriel_shieldofhope.png": 54944,
	"./talents/azmodan/azmodan_allshallburn.png": 44978,
	"./talents/azmodan/azmodan_blackpool.png": 317,
	"./talents/azmodan/azmodan_demonicinvasion.png": 37338,
	"./talents/azmodan/azmodan_generalofhell.png": 77212,
	"./talents/azmodan/azmodan_globeofannihilation.png": 35918,
	"./talents/azmodan/azmodan_globeofannihilation_a.png": 94362,
	"./talents/azmodan/azmodan_globeofannihilation_b.png": 70609,
	"./talents/azmodan/azmodan_summondemonwarrior.png": 49060,
	"./talents/azmodan/azmodan_summondemonwarrior_a.png": 12916,
	"./talents/azmodan/azmodan_trample.png": 86275,
	"./talents/azmodan/talent_autoattack_cooldown.png": 37157,
	"./talents/blaze/blaze_bunker.png": 65155,
	"./talents/blaze/blaze_combustion.png": 34749,
	"./talents/blaze/blaze_flame.png": 42051,
	"./talents/blaze/blaze_jet.png": 44199,
	"./talents/blaze/blaze_new_habits.png": 88248,
	"./talents/blaze/blaze_oil.png": 76322,
	"./talents/blaze/blaze_oil_b.png": 33821,
	"./talents/blaze/blaze_pyromania.png": 83416,
	"./talents/blaze/blaze_stim_1.png": 15555,
	"./talents/blaze/blaze_stim_2.png": 62344,
	"./talents/blaze/blaze_stim_3.png": 18641,
	"./talents/blaze/blaze_vanadium_plating.png": 65447,
	"./talents/blaze/talent_autoattack_building.png": 85536,
	"./talents/blaze/talent_autoattack_slow.png": 25943,
	"./talents/brightwing/brightwing_arcaneflare.png": 20604,
	"./talents/brightwing/brightwing_blinkheal.png": 53198,
	"./talents/brightwing/brightwing_counter_magic.webp": 97831,
	"./talents/brightwing/brightwing_emeraldwind.png": 84096,
	"./talents/brightwing/brightwing_hypershift.png": 95650,
	"./talents/brightwing/brightwing_pixiedust.png": 10991,
	"./talents/brightwing/brightwing_pixiedust_a.png": 15219,
	"./talents/brightwing/brightwing_pixiedust_b.png": 69464,
	"./talents/brightwing/brightwing_polymorph.png": 63026,
	"./talents/brightwing/brightwing_soothingmist.png": 44840,
	"./talents/brightwing/brightwing_stasis.png": 32949,
	"./talents/brightwing/talent_autoattack_cooldown.png": 52090,
	"./talents/brightwing/talent_bribe.png": 51479,
	"./talents/cassia/cassia_avoidance.png": 60866,
	"./talents/cassia/cassia_avoidance_b.png": 10557,
	"./talents/cassia/cassia_balllightning.png": 10047,
	"./talents/cassia/cassia_blindinglight.png": 27497,
	"./talents/cassia/cassia_combo_q_e.png": 36622,
	"./talents/cassia/cassia_combo_q_w.png": 72140,
	"./talents/cassia/cassia_fend.png": 96999,
	"./talents/cassia/cassia_innerlight.png": 56934,
	"./talents/cassia/cassia_lightningfury.png": 4802,
	"./talents/cassia/cassia_new_chargedstrikes.png": 57542,
	"./talents/cassia/cassia_new_gloves.png": 64957,
	"./talents/cassia/cassia_ringoftheleech.png": 60031,
	"./talents/cassia/cassia_valkrie.png": 37952,
	"./talents/cassia/cassia_valkyrie.png": 64889,
	"./talents/cassia/talent_autoattack_searing.png": 81015,
	"./talents/chen/chen_breathoffire.png": 31887,
	"./talents/chen/chen_breathoffire_a.png": 98227,
	"./talents/chen/chen_elusivebrew.png": 679,
	"./talents/chen/chen_flyingkick.png": 20185,
	"./talents/chen/chen_fortifyingbrew.png": 43711,
	"./talents/chen/chen_fortifyingbrew_b.png": 79784,
	"./talents/chen/chen_kegsmash.png": 79823,
	"./talents/chen/chen_stagger.png": 78353,
	"./talents/chen/chen_stormearthfire.png": 15063,
	"./talents/chen/chen_stormstoutsecretrecipe.png": 86458,
	"./talents/chen/chen_wanderingkeg.png": 28246,
	"./talents/cho/cho_consumingflame.png": 84360,
	"./talents/cho/cho_hammeroftwilight.png": 86277,
	"./talents/cho/cho_moltenblock.png": 55514,
	"./talents/cho/cho_moltensurge_a.png": 64835,
	"./talents/cho/cho_ogrehide.png": 91489,
	"./talents/cho/cho_ogrehide_var1.png": 76802,
	"./talents/cho/cho_runebomb.png": 61748,
	"./talents/cho/cho_upheaval.png": 46524,
	"./talents/cho/gall_psychoticbreak.png": 56653,
	"./talents/cho/talent_autoattack_aoe.png": 90587,
	"./talents/cho/talent_autoattack_cooldown.png": 35759,
	"./talents/cho/talent_autoattack_damage.png": 39607,
	"./talents/cho/talent_hardenedshield.png": 11916,
	"./talents/chromie/chromie_aethercannon.png": 77352,
	"./talents/chromie/chromie_aethercannon_a.png": 30240,
	"./talents/chromie/chromie_blessing_of_the_bronze.png": 76772,
	"./talents/chromie/chromie_herethere.png": 1642,
	"./talents/chromie/chromie_hyperdrivesreach.png": 80802,
	"./talents/chromie/chromie_looper.png": 30184,
	"./talents/chromie/chromie_sandstrike.png": 67800,
	"./talents/chromie/chromie_timeblock.png": 11228,
	"./talents/chromie/chromie_timetrap.png": 74438,
	"./talents/chromie/chromie_timetrap_a.png": 90530,
	"./talents/chromie/chromie_timetrap_b.png": 4537,
	"./talents/chromie/chromie_timewarp.png": 5173,
	"./talents/chromie/storm_ui_icon_chromie_detonate_timetrap.png": 9158,
	"./talents/chromie/storm_ui_icon_chromie_timetraveler.png": 39137,
	"./talents/chromie/talent_abilitytalent_damage.png": 98717,
	"./talents/chromie/talent_clairvoyance.png": 94899,
	"./talents/deathwing/deathwing_aspect_of_death.png": 6833,
	"./talents/deathwing/deathwing_aspect_of_death_alt1.png": 71524,
	"./talents/deathwing/deathwing_bellowing_roar.png": 43378,
	"./talents/deathwing/deathwing_cataclysm.png": 70203,
	"./talents/deathwing/deathwing_deathdrop.png": 1215,
	"./talents/deathwing/deathwing_destroyer.png": 34185,
	"./talents/deathwing/deathwing_elemental_plating.png": 12573,
	"./talents/deathwing/deathwing_fire_and_fury.png": 74347,
	"./talents/deathwing/deathwing_firestorm.png": 19085,
	"./talents/deathwing/deathwing_heat_wave.png": 66444,
	"./talents/deathwing/deathwing_incinerate.webp": 34941,
	"./talents/deathwing/deathwing_molten_flame.png": 26933,
	"./talents/deathwing/deathwing_onslaught.webp": 66350,
	"./talents/deathwing/deathwing_ruination.png": 70159,
	"./talents/deathwing/deathwing_skyfall.png": 66770,
	"./talents/deckard/deckard_angelic_conduit.png": 22642,
	"./talents/deckard/deckard_emerald.png": 4158,
	"./talents/deckard/deckard_healing_potion.png": 96680,
	"./talents/deckard/deckard_horadric_cube.png": 86300,
	"./talents/deckard/deckard_horadric_staff.png": 52145,
	"./talents/deckard/deckard_kanais_cube.png": 87879,
	"./talents/deckard/deckard_lorenado.png": 84344,
	"./talents/deckard/deckard_perfect_gems.png": 66722,
	"./talents/deckard/deckard_protectors_of_cain.png": 69467,
	"./talents/deckard/deckard_rejuvination_potion.png": 27382,
	"./talents/deckard/deckard_ruby.png": 45964,
	"./talents/deckard/deckard_sapphire.png": 89698,
	"./talents/deckard/deckard_scroll_of_sealing.png": 43919,
	"./talents/deckard/deckard_scroll_of_sealing_a.png": 97587,
	"./talents/deckard/deckard_stay_awhile_and_listen.png": 56758,
	"./talents/deckard/deckard_study_time.png": 50501,
	"./talents/deckard/deckard_super_healing_potion.png": 44740,
	"./talents/deckard/deckard_unstable_healing_potion.png": 79557,
	"./talents/deckard/storm_ui_icon_deckard_angelic_conduit.png": 32311,
	"./talents/deckard/storm_ui_icon_deckard_emerald.png": 73051,
	"./talents/deckard/storm_ui_icon_deckard_horadric_staff.png": 23442,
	"./talents/deckard/storm_ui_icon_deckard_kanais_cube.png": 46286,
	"./talents/deckard/storm_ui_icon_deckard_perfect_gems.png": 94117,
	"./talents/deckard/storm_ui_icon_deckard_protectors_of_cain.png": 48376,
	"./talents/deckard/storm_ui_icon_deckard_rejuvination_potion.png": 90499,
	"./talents/deckard/storm_ui_icon_deckard_ruby.png": 89643,
	"./talents/deckard/storm_ui_icon_deckard_sapphire.png": 72261,
	"./talents/deckard/storm_ui_icon_deckard_scroll_of_sealing_a.png": 52350,
	"./talents/deckard/storm_ui_icon_deckard_super_healing_potion.png": 89155,
	"./talents/deckard/storm_ui_icon_deckard_unstable_healing_potion.png": 4660,
	"./talents/dehaka/dehaka_adaptation.png": 61185,
	"./talents/dehaka/dehaka_brushstalker.png": 76074,
	"./talents/dehaka/dehaka_burrow.png": 33011,
	"./talents/dehaka/dehaka_drag.png": 53836,
	"./talents/dehaka/dehaka_drag_var1.png": 44889,
	"./talents/dehaka/dehaka_essencecollection.png": 65058,
	"./talents/dehaka/dehaka_essencecollection_var1.png": 52815,
	"./talents/dehaka/dehaka_evolve_mutation.webp": 89248,
	"./talents/dehaka/dehaka_intimidating_roar.webp": 43167,
	"./talents/dehaka/dehaka_isolation.png": 86324,
	"./talents/dehaka/dehaka_leap.webp": 20929,
	"./talents/dehaka/dehaka_scorching_breath.webp": 17756,
	"./talents/dehaka/dehaka_trample.png": 49221,
	"./talents/dehaka/dehaka_trample_a.png": 20493,
	"./talents/diablo/diablo_apocalypse.png": 66889,
	"./talents/diablo/diablo_blacksoulstone_var1.png": 19540,
	"./talents/diablo/diablo_combo_1.png": 30140,
	"./talents/diablo/diablo_firestomp.png": 18965,
	"./talents/diablo/diablo_lightningbreath.png": 53946,
	"./talents/diablo/diablo_lordofterror.png": 64596,
	"./talents/diablo/diablo_overpower_var1.png": 29392,
	"./talents/diablo/diablo_shadowcharge_var1.png": 90589,
	"./talents/diablo/talent_autoattack_damage.png": 3692,
	"./talents/diablo/talent_autoattack_heal.png": 42497,
	"./talents/diablo/talent_boltofthestorm.png": 81173,
	"./talents/diablo/talent_hardenedshield.png": 68289,
	"./talents/dva/dva_bigshot.png": 66680,
	"./talents/dva/dva_boosters.png": 72155,
	"./talents/dva/dva_boosters_a.png": 16775,
	"./talents/dva/dva_bunnyhop.png": 90885,
	"./talents/dva/dva_defensematrix.png": 21497,
	"./talents/dva/dva_mechmode.png": 54022,
	"./talents/dva/dva_mechmode_a.png": 93922,
	"./talents/dva/dva_mechmode_b.png": 33657,
	"./talents/dva/dva_micromissiles.png": 8021,
	"./talents/dva/dva_pilotmode.png": 33161,
	"./talents/dva/dva_selfdestruct.png": 62644,
	"./talents/etc/etc_echopedal.png": 58107,
	"./talents/etc/etc_facemelt.png": 34309,
	"./talents/etc/etc_facemelt_a.png": 3821,
	"./talents/etc/etc_facemelt_b.png": 22198,
	"./talents/etc/etc_guitarsolo.png": 63291,
	"./talents/etc/etc_guitarsolo_a.png": 80231,
	"./talents/etc/etc_moshpit.png": 6942,
	"./talents/etc/etc_moshpit_a.png": 83722,
	"./talents/etc/etc_powerslide.png": 9138,
	"./talents/etc/etc_rockstar.png": 59631,
	"./talents/etc/etc_speedmetal.png": 13498,
	"./talents/etc/etc_stagedive.png": 32942,
	"./talents/etc/talent_boltofthestorm.png": 59038,
	"./talents/etc/talent_imposingpresence.png": 73691,
	"./talents/etc/talent_stormshield.png": 40430,
	"./talents/falstad/falstad_barrelroll.png": 55929,
	"./talents/falstad/falstad_epicmount.png": 49408,
	"./talents/falstad/falstad_hammerang.png": 35716,
	"./talents/falstad/falstad_hammerang_a.png": 31060,
	"./talents/falstad/falstad_hinterlandblast.png": 92127,
	"./talents/falstad/falstad_lightningrod.png": 76581,
	"./talents/falstad/falstad_mightygust.png": 12947,
	"./talents/falstad/falstad_tailwind.png": 30432,
	"./talents/falstad/falstad_tailwind_a.png": 52104,
	"./talents/falstad/talent_autoattack_heal.png": 19811,
	"./talents/falstad/talent_autoattack_range.png": 60770,
	"./talents/fenix/fenix_q.png": 19243,
	"./talents/fenix/fenix_r_planet_cracker.png": 57573,
	"./talents/fenix/fenix_r_scan.png": 37470,
	"./talents/fenix/fenix_shield_1.png": 91619,
	"./talents/fenix/fenix_shield_2.png": 6344,
	"./talents/fenix/fenix_shield_3.png": 20561,
	"./talents/fenix/fenix_teleport.png": 20277,
	"./talents/fenix/fenix_w_1.png": 53029,
	"./talents/fenix/fenix_w_2.png": 82670,
	"./talents/fenix/talent_autoattack_cooldown.png": 80683,
	"./talents/gall/cho_runebomb_var1.png": 91803,
	"./talents/gall/gall_chaoscollision.png": 17690,
	"./talents/gall/gall_chaoscollision_var1.png": 78855,
	"./talents/gall/gall_detonaterunes.png": 70659,
	"./talents/gall/gall_eyeofkilrogg.png": 27901,
	"./talents/gall/gall_ogrerage.png": 84240,
	"./talents/gall/gall_psychoticbreak.png": 39207,
	"./talents/gall/gall_shadowboltvolley.png": 16308,
	"./talents/gall/gall_shadowflame.png": 53109,
	"./talents/gall/gall_shadowflame_var1.png": 34302,
	"./talents/gall/gall_shove.png": 61587,
	"./talents/gall/gall_shove_a.png": 1967,
	"./talents/gall/gall_twistingnether_a.png": 87299,
	"./talents/gall/gall_twoheaded.png": 93735,
	"./talents/garrosh/garrosh_armor_up.png": 7167,
	"./talents/garrosh/garrosh_bloodthirst.png": 44410,
	"./talents/garrosh/garrosh_bloodthirst_var1.png": 86887,
	"./talents/garrosh/garrosh_decimate.png": 58170,
	"./talents/garrosh/garrosh_groundbreaker.png": 24793,
	"./talents/garrosh/garrosh_indomitablel.png": 75860,
	"./talents/garrosh/garrosh_intothefray.png": 27543,
	"./talents/garrosh/garrosh_slam.png": 55231,
	"./talents/garrosh/garrosh_warlords_challenge.png": 26876,
	"./talents/garrosh/garrosh_wrecking_ball.png": 76820,
	"./talents/gazlowe/200014-cardboard-assassin.jpg": 65340,
	"./talents/gazlowe/Ability_mount_rocketmount3.webp": 89418,
	"./talents/gazlowe/Portable_Mailbox.webp": 23813,
	"./talents/gazlowe/gazlowe_bg.webm": 6835,
	"./talents/gazlowe/gazlowe_combo_q_w.png": 30050,
	"./talents/gazlowe/gazlowe_combo_w_e.png": 6018,
	"./talents/gazlowe/gazlowe_dethlazor.png": 46179,
	"./talents/gazlowe/gazlowe_dethlazor_a.png": 84255,
	"./talents/gazlowe/gazlowe_explodiumcharge.png": 19203,
	"./talents/gazlowe/gazlowe_gravobomb.png": 28139,
	"./talents/gazlowe/gazlowe_robogoblin.png": 54169,
	"./talents/gazlowe/gazlowe_rockitturret.png": 64118,
	"./talents/gazlowe/gazlowe_rockitturret_var1.png": 40267,
	"./talents/gazlowe/gazlowe_rockitturret_var2.png": 52624,
	"./talents/gazlowe/gazlowe_salvager.png": 46623,
	"./talents/gazlowe/storm_ui_icon_gazlowe_combo_q_w.png": 69871,
	"./talents/gazlowe/storm_ui_icon_gazlowe_combo_w_e.png": 3031,
	"./talents/gazlowe/storm_ui_icon_gazlowe_dethlazor.png": 93130,
	"./talents/gazlowe/storm_ui_icon_gazlowe_dethlazor_a.png": 6014,
	"./talents/gazlowe/storm_ui_icon_gazlowe_explodiumcharge.png": 50090,
	"./talents/gazlowe/storm_ui_icon_gazlowe_gravobomb.png": 87018,
	"./talents/gazlowe/storm_ui_icon_gazlowe_itsrainingscrap.png": 6844,
	"./talents/gazlowe/storm_ui_icon_gazlowe_robogoblin.png": 76917,
	"./talents/gazlowe/storm_ui_icon_gazlowe_rockitturret.png": 54249,
	"./talents/gazlowe/storm_ui_icon_gazlowe_rockitturret_var1.png": 85834,
	"./talents/gazlowe/storm_ui_icon_gazlowe_rockitturret_var2.png": 65646,
	"./talents/gazlowe/storm_ui_icon_gazlowe_salvager.png": 82832,
	"./talents/gazlowe/storm_ui_icon_gazlowe_salvager_var1.png": 10501,
	"./talents/gazlowe/storm_ui_icon_talent_autoattack_searing.png": 86213,
	"./talents/gazlowe/storm_ui_icon_talent_imposingpresence.png": 11261,
	"./talents/gazlowe/talent1.png": 67425,
	"./talents/gazlowe/talent_autoattack_damage.png": 70956,
	"./talents/gazlowe/talent_autoattack_searing.png": 44348,
	"./talents/gazlowe/talent_imposingpresence.png": 15304,
	"./talents/gazlowe/ui_profession_engineering.jpg": 13429,
	"./talents/genji/genji_cyberagility.png": 72804,
	"./talents/genji/genji_cyberagility_a.png": 48436,
	"./talents/genji/genji_deflect.png": 55351,
	"./talents/genji/genji_deflect_a.png": 59723,
	"./talents/genji/genji_dragonblade.png": 67631,
	"./talents/genji/genji_shurikens.png": 64842,
	"./talents/genji/genji_shurikens_dragonsoul.png": 44555,
	"./talents/genji/genji_shurikens_xblade.png": 33857,
	"./talents/genji/genji_swiftstrike.png": 36769,
	"./talents/genji/genji_swiftstrike_a.png": 60481,
	"./talents/genji/talent_autoattack_damage.png": 27268,
	"./talents/greymane/greymane_beastfocus.png": 8085,
	"./talents/greymane/greymane_beastfocus_var1.png": 10622,
	"./talents/greymane/greymane_curseoftheworgen.png": 39990,
	"./talents/greymane/greymane_curseoftheworgen_var1.png": 42731,
	"./talents/greymane/greymane_darkflight.png": 55728,
	"./talents/greymane/greymane_disengage.png": 785,
	"./talents/greymane/greymane_goforthethroat.png": 74704,
	"./talents/greymane/greymane_qattack.png": 86421,
	"./talents/greymane/greymane_snapshot.png": 66338,
	"./talents/greymane/greymane_swipe.png": 67914,
	"./talents/greymane/talent_autoattack_damage.png": 78669,
	"./talents/guldan/guldan_darkbargain.png": 44156,
	"./talents/guldan/guldan_darkpact.png": 10732,
	"./talents/guldan/guldan_demoniccircle.png": 55,
	"./talents/guldan/guldan_felflame.png": 58042,
	"./talents/guldan/guldan_handofguldan.png": 59905,
	"./talents/guldan/guldan_healthfunnel.png": 93758,
	"./talents/guldan/guldan_healthstone.png": 54071,
	"./talents/guldan/guldan_horrify.png": 62961,
	"./talents/guldan/guldan_hungerforpower.png": 1129,
	"./talents/guldan/guldan_lifetap.png": 70251,
	"./talents/guldan/guldan_rainoffire.png": 86749,
	"./talents/hanzo/hanzo_draconicadvantage.png": 5510,
	"./talents/hanzo/hanzo_dragonstrike.png": 63147,
	"./talents/hanzo/hanzo_fromonething.png": 63856,
	"./talents/hanzo/hanzo_grabthereins.png": 81408,
	"./talents/hanzo/hanzo_kaijuhunter.png": 64114,
	"./talents/hanzo/hanzo_piercingarrows.png": 83703,
	"./talents/hanzo/hanzo_redemption.png": 66063,
	"./talents/hanzo/hanzo_scatterarrow.png": 59481,
	"./talents/hanzo/hanzo_shieldbreaker.png": 74795,
	"./talents/hanzo/hanzo_sonicarrow.png": 82323,
	"./talents/hanzo/hanzo_stormbow.png": 81641,
	"./talents/hanzo/hanzo_thedragonsarrow.png": 53584,
	"./talents/hanzo/hanzo_wallvault.png": 14026,
	"./talents/hexagon.png": 26702,
	"./talents/hogger/hogger_combo_q_d.png": 82135,
	"./talents/hogger/hogger_e.png": 31445,
	"./talents/hogger/hogger_e_variant.png": 40163,
	"./talents/hogger/hogger_q.png": 2017,
	"./talents/hogger/hogger_r1.png": 40633,
	"./talents/hogger/hogger_r2.png": 84546,
	"./talents/hogger/hogger_rage.png": 21973,
	"./talents/hogger/hogger_trait.png": 90192,
	"./talents/hogger/hogger_w.png": 25412,
	"./talents/hogger/talent_autoattack_damage.png": 88681,
	"./talents/hogger/talent_autoattack_heal.png": 18028,
	"./talents/illidan/illidan_betrayersthirst.png": 82527,
	"./talents/illidan/illidan_betrayersthirst_a.png": 63715,
	"./talents/illidan/illidan_dive.png": 73942,
	"./talents/illidan/illidan_dive_a.png": 82258,
	"./talents/illidan/illidan_evasion.png": 46811,
	"./talents/illidan/illidan_evasion_a.png": 29511,
	"./talents/illidan/illidan_metamorphosis.png": 25859,
	"./talents/illidan/illidan_sweepingstrike.png": 83150,
	"./talents/illidan/illidan_sweepingstrike_a.png": 92410,
	"./talents/illidan/illidan_sweepingstrike_c.png": 20264,
	"./talents/illidan/illidan_thehunt.png": 35264,
	"./talents/illidan/talent_autoattack_searing.png": 23905,
	"./talents/illidan/talent_autoattack_slow.png": 43946,
	"./talents/illidan/talent_boltofthestorm.png": 47811,
	"./talents/illidan/talent_seasonedmarksman.png": 4855,
	"./talents/imperius/imperius_e.png": 68093,
	"./talents/imperius/imperius_e_alt_01.png": 28927,
	"./talents/imperius/imperius_globe.png": 20563,
	"./talents/imperius/imperius_item_01.png": 98633,
	"./talents/imperius/imperius_item_02.png": 7922,
	"./talents/imperius/imperius_item_03.png": 5787,
	"./talents/imperius/imperius_q.png": 5769,
	"./talents/imperius/imperius_r1.png": 74526,
	"./talents/imperius/imperius_r2.png": 21978,
	"./talents/imperius/imperius_trait.png": 23080,
	"./talents/imperius/imperius_w.png": 9599,
	"./talents/jaina/BTNMassTeleport.webp": 91750,
	"./talents/jaina/PASBTNBrilliance.webp": 98382,
	"./talents/jaina/jaina_arcaneintellect.png": 13932,
	"./talents/jaina/jaina_blizzard.png": 62178,
	"./talents/jaina/jaina_coneofcold.png": 54928,
	"./talents/jaina/jaina_coneofcold_var1.png": 34085,
	"./talents/jaina/jaina_frostarmor.png": 34307,
	"./talents/jaina/jaina_frostbite.png": 57682,
	"./talents/jaina/jaina_frostbolt.png": 95997,
	"./talents/jaina/jaina_icyveins.png": 73046,
	"./talents/jaina/jaina_ringoffrost.png": 74323,
	"./talents/jaina/jaina_summonwaterelemental.png": 98681,
	"./talents/jaina/talent_autoattack_cooldown.png": 36070,
	"./talents/jaina/talent_boltofthestorm.png": 47247,
	"./talents/jaina/talent_conjurerspursuit.png": 5784,
	"./talents/johanna/akarat.png": 62834,
	"./talents/johanna/apprentice.png": 16017,
	"./talents/johanna/johanna_blessed_shield.png": 90290,
	"./talents/johanna/johanna_condemn.png": 54198,
	"./talents/johanna/johanna_falling_sword.png": 97117,
	"./talents/johanna/johanna_indestructible.png": 3827,
	"./talents/johanna/johanna_iron_skin.png": 312,
	"./talents/johanna/johanna_lawsofhope.png": 30654,
	"./talents/johanna/johanna_punish.png": 27791,
	"./talents/johanna/johanna_shield_glare.png": 87679,
	"./talents/johanna/storm_btn_d3ros_crusader_blessedhammer.png": 23489,
	"./talents/johanna/storm_btn_d3ros_crusader_steedcharge.png": 14716,
	"./talents/johanna/talent_autoattack_cooldown.png": 65256,
	"./talents/johanna/talent_block.png": 76896,
	"./talents/johanna/talent_burningrage.png": 39037,
	"./talents/johanna/talent_stormshield.png": 53999,
	"./talents/junkrat/junkrat_bomb_pack.png": 83590,
	"./talents/junkrat/junkrat_concussion_mine.png": 20744,
	"./talents/junkrat/junkrat_frag_launcher.png": 46665,
	"./talents/junkrat/junkrat_frag_launcher_b.png": 53954,
	"./talents/junkrat/junkrat_frag_launcher_d.png": 29172,
	"./talents/junkrat/junkrat_frag_launcher_e.png": 50301,
	"./talents/junkrat/junkrat_frag_launcher_f.png": 9062,
	"./talents/junkrat/junkrat_frag_launcher_g.png": 48079,
	"./talents/junkrat/junkrat_mount_rocket.png": 5650,
	"./talents/junkrat/junkrat_rip_tire.png": 69754,
	"./talents/junkrat/junkrat_rocket_ride.png": 80035,
	"./talents/junkrat/junkrat_steel_trap.png": 85293,
	"./talents/junkrat/junkrat_steel_trap_a.png": 48837,
	"./talents/junkrat/junkrat_trap_mine.png": 25339,
	"./talents/kaelthas/felomelorn.jpg": 73157,
	"./talents/kaelthas/kaelthas_flamestrike.png": 2113,
	"./talents/kaelthas/kaelthas_gravitylapse.png": 5537,
	"./talents/kaelthas/kaelthas_gravitylapse_a.png": 59137,
	"./talents/kaelthas/kaelthas_livingbomb.png": 14455,
	"./talents/kaelthas/kaelthas_livingbomb_b.png": 60784,
	"./talents/kaelthas/kaelthas_livingbomb_var1.png": 98744,
	"./talents/kaelthas/kaelthas_manaaddict.png": 36850,
	"./talents/kaelthas/kaelthas_phoenix.png": 1467,
	"./talents/kaelthas/kaelthas_pyroblast.png": 83932,
	"./talents/kaelthas/kaelthas_verdantspheres.png": 32250,
	"./talents/kaelthas/manadrain.webp": 13848,
	"./talents/kelthuzad/kelthuzad_armorofthearchlich.png": 68955,
	"./talents/kelthuzad/kelthuzad_chains.png": 36694,
	"./talents/kelthuzad/kelthuzad_chains_a.png": 40626,
	"./talents/kelthuzad/kelthuzad_chillingtouch.png": 36165,
	"./talents/kelthuzad/kelthuzad_cultofthedamned.png": 92793,
	"./talents/kelthuzad/kelthuzad_deathanddecay.png": 94239,
	"./talents/kelthuzad/kelthuzad_frostnova.png": 18990,
	"./talents/kelthuzad/kelthuzad_frozentomb.png": 92672,
	"./talents/kelthuzad/kelthuzad_glacialspike.png": 18421,
	"./talents/kelthuzad/kelthuzad_masterofthecolddark.webp": 78039,
	"./talents/kelthuzad/kelthuzad_phylactery.png": 49609,
	"./talents/kelthuzad/kelthuzad_poweroficecrown.png": 77380,
	"./talents/kelthuzad/kelthuzad_shadowfissure.png": 32755,
	"./talents/kelthuzad/kelthuzad_shiftingmalice.png": 13367,
	"./talents/kelthuzad/talent_abilitytalent_damage.png": 11128,
	"./talents/kerrigan/kerrigan_assimilation.png": 7049,
	"./talents/kerrigan/kerrigan_chrysalis.png": 59916,
	"./talents/kerrigan/kerrigan_impalingblades.png": 85978,
	"./talents/kerrigan/kerrigan_maelstrom.png": 7028,
	"./talents/kerrigan/kerrigan_primalgrasp.png": 23130,
	"./talents/kerrigan/kerrigan_ravage.png": 64188,
	"./talents/kerrigan/kerrigan_ravage_b.png": 34948,
	"./talents/kerrigan/kerrigan_ultralisk.png": 54475,
	"./talents/kerrigan/talent_abilitytalent_damage.png": 62073,
	"./talents/kerrigan/talent_autoattack_aoe.png": 90324,
	"./talents/kerrigan/talent_autoattack_cooldown.png": 5098,
	"./talents/kerrigan/talent_autoattack_damage.png": 13646,
	"./talents/kerrigan/talent_boltofthestorm.png": 50771,
	"./talents/kharazim/kharazim_epiphany.png": 32046,
	"./talents/kharazim/kharazim_fistoflegend.png": 19574,
	"./talents/kharazim/monk_allyair.png": 55630,
	"./talents/kharazim/monk_allyearth.png": 56814,
	"./talents/kharazim/monk_allyspirit.png": 99051,
	"./talents/kharazim/monk_breathofheaven.png": 70406,
	"./talents/kharazim/monk_dash.png": 25662,
	"./talents/kharazim/monk_dash_a.png": 37418,
	"./talents/kharazim/monk_deadlyreach.png": 67212,
	"./talents/kharazim/monk_divinepalm.png": 18599,
	"./talents/kharazim/monk_sevensidedstrike.png": 62370,
	"./talents/kharazim/monk_trait_insight.png": 46481,
	"./talents/kharazim/monk_trait_ironfist.png": 89861,
	"./talents/kharazim/monk_trait_transcendence.png": 21840,
	"./talents/kharazim/talent_relentless.png": 78112,
	"./talents/kharazim/talent_spellshield.png": 1914,
	"./talents/kharazim/talent_stormshield.png": 9979,
	"./talents/leoric/leoric_drainhope.png": 78128,
	"./talents/leoric/leoric_drainhope_var1.png": 58341,
	"./talents/leoric/leoric_drainhope_var2.png": 55918,
	"./talents/leoric/leoric_entomb.png": 71553,
	"./talents/leoric/leoric_r2.png": 1442,
	"./talents/leoric/leoric_skeletalswing.png": 93013,
	"./talents/leoric/leoric_skeletalswing_var1.png": 65982,
	"./talents/leoric/leoric_skeletalswing_var2.png": 51733,
	"./talents/leoric/leoric_trait.png": 69904,
	"./talents/leoric/leoric_wraithwalk.png": 41100,
	"./talents/leoric/talent_amplifiedhealing.png": 20853,
	"./talents/leoric/talent_autoattack_heal.png": 66926,
	"./talents/leoric/talent_autoattack_speed.png": 57311,
	"./talents/leoric/talent_hardenedshield.png": 55668,
	"./talents/li-ming/talent_autoattack_damage.png": 61340,
	"./talents/li-ming/talent_powerhungry.png": 60871,
	"./talents/li-ming/wizard_arcaneorb.png": 63421,
	"./talents/li-ming/wizard_archon.png": 47017,
	"./talents/li-ming/wizard_criticalmass.png": 4737,
	"./talents/li-ming/wizard_disintegrate.png": 72759,
	"./talents/li-ming/wizard_elementalexposure.png": 54376,
	"./talents/li-ming/wizard_glasscannon.png": 68215,
	"./talents/li-ming/wizard_magicmissiles.png": 49566,
	"./talents/li-ming/wizard_magicmissiles_b.png": 34401,
	"./talents/li-ming/wizard_teleport.png": 3875,
	"./talents/li-ming/wizard_waveofforce.png": 70365,
	"./talents/lili/storm_ui_icon_lili_blindingwind.png": 35858,
	"./talents/lili/storm_ui_icon_lili_blindingwind_a.png": 68758,
	"./talents/lili/storm_ui_icon_lili_blindingwind_b.png": 50381,
	"./talents/lili/storm_ui_icon_lili_cloudserpent.png": 10891,
	"./talents/lili/storm_ui_icon_lili_fastfeet.png": 85049,
	"./talents/lili/storm_ui_icon_lili_healingbrew.png": 38473,
	"./talents/lili/storm_ui_icon_lili_healingbrew_a.png": 3737,
	"./talents/lili/storm_ui_icon_lili_jugofathousandcups.png": 77572,
	"./talents/lili/storm_ui_icon_lili_mistweaver.png": 92604,
	"./talents/lili/storm_ui_icon_lili_waterdragon.png": 94963,
	"./talents/lili/storm_ui_icon_talent_cleanse.png": 45162,
	"./talents/lili/talent1.png": 77446,
	"./talents/lt-morales/medic_advancedblock.png": 68001,
	"./talents/lt-morales/medic_deployshield.png": 48476,
	"./talents/lt-morales/medic_deployshield_b.png": 45751,
	"./talents/lt-morales/medic_deployshield_c.png": 16526,
	"./talents/lt-morales/medic_displacementgrenade.png": 15205,
	"./talents/lt-morales/medic_displacementgrenade_b.png": 61590,
	"./talents/lt-morales/medic_displacementgrenade_c.png": 15391,
	"./talents/lt-morales/medic_healingbeam.png": 5863,
	"./talents/lt-morales/medic_healingbeam_c.png": 30569,
	"./talents/lt-morales/medic_medivacdropship.png": 69482,
	"./talents/lt-morales/medic_stim.png": 50701,
	"./talents/lt-morales/talent_autoattack_mana.png": 98265,
	"./talents/lt-morales/upgrade-terran-mobiusreactor.png": 83350,
	"./talents/lucio/lucio.png": 55783,
	"./talents/lucio/lucio_accelerando.png": 7785,
	"./talents/lucio/lucio_ampitup.png": 69580,
	"./talents/lucio/lucio_ampitup_a.png": 50956,
	"./talents/lucio/lucio_ampitup_b.png": 1639,
	"./talents/lucio/lucio_crossfade_a.png": 18760,
	"./talents/lucio/lucio_crossfade_all.png": 16456,
	"./talents/lucio/lucio_fineshrine.png": 27305,
	"./talents/lucio/lucio_highfive.png": 69576,
	"./talents/lucio/lucio_soundbarrier.png": 43402,
	"./talents/lucio/lucio_soundwave.png": 3224,
	"./talents/lucio/lucio_soundwave_a.png": 9200,
	"./talents/lucio/lucio_wallride.png": 25970,
	"./talents/lucio/lucio_wallride_a.png": 38646,
	"./talents/lucio/storm_ui_icon_lucio_accelerando.png": 52396,
	"./talents/lucio/storm_ui_icon_lucio_ampitup.png": 40817,
	"./talents/lucio/storm_ui_icon_lucio_ampitup_a.png": 72561,
	"./talents/lucio/storm_ui_icon_lucio_ampitup_b.png": 42394,
	"./talents/lucio/storm_ui_icon_lucio_crossfade_a.png": 67057,
	"./talents/lucio/storm_ui_icon_lucio_crossfade_all.png": 78145,
	"./talents/lucio/storm_ui_icon_lucio_crossfadehealing.png": 7547,
	"./talents/lucio/storm_ui_icon_lucio_crossfadespeed.png": 25880,
	"./talents/lucio/storm_ui_icon_lucio_fineshrine.png": 5046,
	"./talents/lucio/storm_ui_icon_lucio_highfive.png": 12231,
	"./talents/lucio/storm_ui_icon_lucio_mount.png": 67948,
	"./talents/lucio/storm_ui_icon_lucio_soundbarrier.png": 22641,
	"./talents/lucio/storm_ui_icon_lucio_soundwave.png": 37697,
	"./talents/lucio/storm_ui_icon_lucio_soundwave_a.png": 65697,
	"./talents/lucio/storm_ui_icon_lucio_wallride.png": 82705,
	"./talents/lucio/storm_ui_icon_lucio_wallride_a.png": 29617,
	"./talents/lucio/talent1.png": 44508,
	"./talents/lunara/lunara_abolishmagic.png": 1001,
	"./talents/lunara/lunara_boundlessstride.png": 75858,
	"./talents/lunara/lunara_boundlessstride_a.png": 83222,
	"./talents/lunara/lunara_forests_wrath.png": 60689,
	"./talents/lunara/lunara_fullbloom.png": 16374,
	"./talents/lunara/lunara_fullbloom_a.png": 2834,
	"./talents/lunara/lunara_greaterspellshield.png": 28499,
	"./talents/lunara/lunara_pollencloud.png": 48075,
	"./talents/lunara/lunara_pollencloud_b.png": 60476,
	"./talents/lunara/lunara_stiflingblossom.png": 53617,
	"./talents/lunara/lunara_stiflingblossom_var1.png": 94866,
	"./talents/lunara/lunara_wildspear.png": 72953,
	"./talents/lunara/lunara_wisp.png": 38729,
	"./talents/maiev/maiev_heavy_strikes.png": 14471,
	"./talents/maiev/maiev_heroic_1_a.png": 10576,
	"./talents/maiev/maiev_heroic_2.png": 47347,
	"./talents/maiev/maiev_knives.png": 7346,
	"./talents/maiev/maiev_knives_2.png": 37277,
	"./talents/maiev/maiev_memento.png": 49719,
	"./talents/maiev/maiev_orb_corruption.png": 63865,
	"./talents/maiev/maiev_pursuit_vengeance.png": 79487,
	"./talents/maiev/maiev_rush_1.png": 63934,
	"./talents/maiev/maiev_rush_2.png": 661,
	"./talents/maiev/maiev_shadoworb_relentless.png": 34093,
	"./talents/maiev/maiev_shadoworb_strike.png": 67304,
	"./talents/maiev/maiev_shadoworb_vengeance.png": 83458,
	"./talents/maiev/maiev_umbra_1.png": 97381,
	"./talents/maiev/maiev_vaultofthewardens.webp": 38997,
	"./talents/malfurion/malfurion_entanglingroots.png": 56890,
	"./talents/malfurion/malfurion_entanglingroots_a.png": 64046,
	"./talents/malfurion/malfurion_entanglingroots_b.png": 91877,
	"./talents/malfurion/malfurion_innervate.png": 86612,
	"./talents/malfurion/malfurion_moonfire.png": 34499,
	"./talents/malfurion/malfurion_regrowth.png": 68530,
	"./talents/malfurion/malfurion_tranquility.png": 66428,
	"./talents/malfurion/malfurion_twilightdream.png": 77007,
	"./talents/malfurion/malfurion_wildgrowth.png": 8157,
	"./talents/malfurion/malfurion_wildgrowth_a.png": 41589,
	"./talents/malganis/malganis_blindbat.png": 72896,
	"./talents/malganis/malganis_fel_1.png": 68537,
	"./talents/malganis/malganis_fel_1_b.png": 58290,
	"./talents/malganis/malganis_necrotic.png": 38903,
	"./talents/malganis/malganis_necrotic_b.png": 30128,
	"./talents/malganis/malganis_necrotic_c.png": 36377,
	"./talents/malganis/malganis_nightrush.png": 1864,
	"./talents/malganis/malganis_nightrush_b.png": 50011,
	"./talents/malganis/malganis_trait.png": 33024,
	"./talents/malganis/malganis_trait_b.png": 54115,
	"./talents/malganis/malganis_ult_conversion.png": 76430,
	"./talents/malganis/malganis_ult_swarm.png": 15160,
	"./talents/malthael/malthael_deathshroud.png": 25757,
	"./talents/malthael/malthael_fearthereaper.png": 85310,
	"./talents/malthael/malthael_inevitableend.png": 46882,
	"./talents/malthael/malthael_lastrites.png": 71893,
	"./talents/malthael/malthael_noonecanstopdeath.png": 89451,
	"./talents/malthael/malthael_onpalehorse.png": 9606,
	"./talents/malthael/malthael_reapersmark.png": 78523,
	"./talents/malthael/malthael_shroudofwisdom.png": 25319,
	"./talents/malthael/malthael_soulrip.png": 70422,
	"./talents/malthael/malthael_tormentedsoul.png": 91481,
	"./talents/malthael/malthael_touchofdeath.png": 57898,
	"./talents/malthael/malthael_wraithstrike.png": 41341,
	"./talents/medivh/jaina_arcaneintellect.png": 88764,
	"./talents/medivh/medivh_arcanemissile.png": 12844,
	"./talents/medivh/medivh_arcanemissile_a.png": 16812,
	"./talents/medivh/medivh_dustofappearance.png": 30657,
	"./talents/medivh/medivh_forceofwill.png": 8056,
	"./talents/medivh/medivh_forceofwill_a.png": 17392,
	"./talents/medivh/medivh_forceofwill_b.png": 47563,
	"./talents/medivh/medivh_invisibility.png": 6773,
	"./talents/medivh/medivh_leylineblast.png": 98038,
	"./talents/medivh/medivh_polybomb.png": 52642,
	"./talents/medivh/medivh_portal.png": 13710,
	"./talents/medivh/medivh_portal_a.png": 6330,
	"./talents/medivh/medivh_ravenform.png": 46338,
	"./talents/medivh/medivh_ravenform_b.png": 2781,
	"./talents/mei/arthas_frosentempest.png": 74925,
	"./talents/mei/jaina_frostarmor.png": 8887,
	"./talents/mei/mei_battery.png": 47901,
	"./talents/mei/mei_e1_slide.png": 10220,
	"./talents/mei/mei_q_snowblind.png": 85276,
	"./talents/mei/mei_r1_avalanche.png": 11173,
	"./talents/mei/mei_r2_icewall.png": 51896,
	"./talents/mei/mei_trait.png": 55734,
	"./talents/mei/mei_w_blizzard.png": 79736,
	"./talents/mei/talent_autoattack_damage.png": 78670,
	"./talents/mephisto/mephisto_durance.png": 71170,
	"./talents/mephisto/mephisto_hatred.png": 44800,
	"./talents/mephisto/mephisto_lightning.png": 71284,
	"./talents/mephisto/mephisto_lightning_b.png": 78399,
	"./talents/mephisto/mephisto_shade.png": 2357,
	"./talents/mephisto/mephisto_shade_b.png": 34649,
	"./talents/mephisto/mephisto_shade_c.png": 38575,
	"./talents/mephisto/mephisto_skull.png": 33309,
	"./talents/mephisto/mephisto_souls.png": 52550,
	"./talents/mephisto/mephisto_splash.png": 5873,
	"./talents/modified_icon.svg": 93537,
	"./talents/muradin/muradin_avatar.png": 39703,
	"./talents/muradin/muradin_dwarftoss.png": 55191,
	"./talents/muradin/muradin_haymaker.png": 18258,
	"./talents/muradin/muradin_secondwind.png": 89182,
	"./talents/muradin/muradin_stormbolt.png": 2440,
	"./talents/muradin/muradin_thunderclap.png": 90550,
	"./talents/muradin/muradin_thunderclap_a.png": 63538,
	"./talents/muradin/muradin_thunderclap_b.png": 28681,
	"./talents/muradin/talent_autoattack_damage.png": 75653,
	"./talents/muradin/talent_autoattack_stun.png": 18982,
	"./talents/muradin/talent_burningrage.png": 77228,
	"./talents/muradin/talent_hardenedshield.png": 19518,
	"./talents/muradin/talent_imposingpresence.png": 7043,
	"./talents/muradin/talent_rewind.png": 89613,
	"./talents/murky/murky.png": 38003,
	"./talents/murky/murky_egghunt.png": 93150,
	"./talents/murky/murky_fishtank.png": 98990,
	"./talents/murky/murky_marchofthemurlocs.png": 4346,
	"./talents/murky/murky_octograb.png": 93275,
	"./talents/murky/murky_pufferfish.png": 9170,
	"./talents/murky/murky_pufferfish_b.png": 30349,
	"./talents/murky/murky_safetybubble.png": 98404,
	"./talents/murky/murky_slime.png": 26,
	"./talents/murky/murky_trait_spawnegg.png": 28371,
	"./talents/murky/murky_trait_spawnegg_var1.png": 20556,
	"./talents/murky/talent_autoattack_slow.png": 39251,
	"./talents/murky/talent_bribe.png": 83438,
	"./talents/nazeebo/nazeebo_corpsespider.png": 66659,
	"./talents/nazeebo/nazeebo_gargantuan.png": 66952,
	"./talents/nazeebo/nazeebo_plagueoftoads.png": 14770,
	"./talents/nazeebo/nazeebo_ravenousspirit.png": 25478,
	"./talents/nazeebo/nazeebo_soulharvest.png": 41014,
	"./talents/nazeebo/nazeebo_suprerstition.png": 53011,
	"./talents/nazeebo/nazeebo_voodooritual.png": 45467,
	"./talents/nazeebo/nazeebo_voodooritual_a.png": 36295,
	"./talents/nazeebo/nazeebo_zombiewall.png": 19058,
	"./talents/nazeebo/talent_elunesgrace.png": 91030,
	"./talents/nazeebo/talent_iceblock.png": 65854,
	"./talents/nova/nova_holodecoy.png": 35328,
	"./talents/nova/nova_holodecoy_var2.png": 126,
	"./talents/nova/nova_orbitalstrike.png": 59849,
	"./talents/nova/nova_personalcloaking.png": 73762,
	"./talents/nova/nova_pinningshot.png": 84411,
	"./talents/nova/nova_pinningshot_var1.png": 56180,
	"./talents/nova/nova_snipe.png": 45953,
	"./talents/nova/nova_tripletap.png": 81807,
	"./talents/nova/talent_antiarmorshells.png": 45263,
	"./talents/nova/talent_autoattack_damage.png": 97507,
	"./talents/nova/talent_bribe.png": 76910,
	"./talents/nova/talent_rewind.png": 60983,
	"./talents/orphea/orphea_e.png": 26667,
	"./talents/orphea/orphea_e_terror.png": 73770,
	"./talents/orphea/orphea_q.png": 51295,
	"./talents/orphea/orphea_reset.png": 22731,
	"./talents/orphea/orphea_trait.png": 35186,
	"./talents/orphea/orphea_ult_darkfall.png": 53043,
	"./talents/orphea/orphea_ult_thrasher.png": 31915,
	"./talents/orphea/orphea_w.png": 47465,
	"./talents/orphea/orphea_w_2.png": 47218,
	"./talents/probius/probius_disruptionpulse.png": 84508,
	"./talents/probius/probius_photoncannon.png": 68037,
	"./talents/probius/probius_pylonovercharge.png": 26100,
	"./talents/probius/probius_shieldcapacitor.png": 48215,
	"./talents/probius/probius_voidgate.png": 81179,
	"./talents/probius/probius_warpinpylon.png": 77271,
	"./talents/probius/probius_warpinpylon_a.png": 2123,
	"./talents/probius/probius_warpinpylon_b.png": 32272,
	"./talents/probius/probius_warprift.png": 81163,
	"./talents/probius/probius_warprift_a.png": 85111,
	"./talents/probius/probius_warprift_c.png": 97093,
	"./talents/probius/probius_workerrush.png": 20316,
	"./talents/qhira/nexushunter_d.png": 94962,
	"./talents/qhira/nexushunter_e.png": 43963,
	"./talents/qhira/nexushunter_e_alt_1.png": 60651,
	"./talents/qhira/nexushunter_e_alt_2.png": 95248,
	"./talents/qhira/nexushunter_passive.png": 38345,
	"./talents/qhira/nexushunter_passive_alt_1.png": 9553,
	"./talents/qhira/nexushunter_q.png": 63887,
	"./talents/qhira/nexushunter_r1.png": 50039,
	"./talents/qhira/nexushunter_r2.png": 91932,
	"./talents/qhira/nexushunter_w.png": 74265,
	"./talents/qhira/storm_ui_icon_nexushunter_d.png": 89163,
	"./talents/qhira/storm_ui_icon_nexushunter_e.png": 51682,
	"./talents/qhira/storm_ui_icon_nexushunter_e_alt_1.png": 37722,
	"./talents/qhira/storm_ui_icon_nexushunter_e_alt_2.png": 62385,
	"./talents/qhira/storm_ui_icon_nexushunter_passive.png": 55488,
	"./talents/qhira/storm_ui_icon_nexushunter_passive_alt_1.png": 35496,
	"./talents/qhira/storm_ui_icon_nexushunter_q.png": 19350,
	"./talents/qhira/storm_ui_icon_nexushunter_r1.png": 83472,
	"./talents/qhira/storm_ui_icon_nexushunter_r2.png": 65227,
	"./talents/qhira/storm_ui_icon_nexushunter_w.png": 38784,
	"./talents/qhira/talent1.png": 83887,
	"./talents/ragnaros/ragnaros_blastwave.png": 50895,
	"./talents/ragnaros/ragnaros_catchingfire.png": 17359,
	"./talents/ragnaros/ragnaros_empowersulfuras.png": 7272,
	"./talents/ragnaros/ragnaros_lavawave.png": 54273,
	"./talents/ragnaros/ragnaros_livingmeteor.png": 24487,
	"./talents/ragnaros/ragnaros_moltencore.png": 22160,
	"./talents/ragnaros/ragnaros_submerge.png": 23658,
	"./talents/ragnaros/ragnaros_sulfurassmash.png": 44471,
	"./talents/ragnaros/talent_autoattack_damage.png": 64532,
	"./talents/ragnaros/talent_resistance.png": 43496,
	"./talents/raynor/DropPod_SC2_Rend1.webp": 39231,
	"./talents/raynor/Vulture_WoL.webp": 25117,
	"./talents/raynor/raynor_acardtoplay.png": 20980,
	"./talents/raynor/raynor_acquireweakspot.png": 83998,
	"./talents/raynor/raynor_adrenalinrush.png": 92572,
	"./talents/raynor/raynor_advancedoptics.png": 3104,
	"./talents/raynor/raynor_hulkarmor.png": 44977,
	"./talents/raynor/raynor_hyperion.png": 10600,
	"./talents/raynor/raynor_inspire.png": 77444,
	"./talents/raynor/raynor_penetratinground.png": 62039,
	"./talents/raynor/raynor_raynorsraiders.png": 57704,
	"./talents/raynor/raynor_split_debilitatingrounds.png": 58326,
	"./talents/raynor/s.png": 56923,
	"./talents/raynor/sg.png": 12044,
	"./talents/raynor/storm_ui_icon_raynor_acardtoplay.png": 95055,
	"./talents/raynor/storm_ui_icon_raynor_advancedoptics.png": 86261,
	"./talents/raynor/storm_ui_icon_raynor_commandraynorsraiders.png": 27042,
	"./talents/raynor/storm_ui_icon_raynor_hulkarmor.png": 49454,
	"./talents/raynor/storm_ui_icon_raynor_inspire_a.png": 71851,
	"./talents/raynor/storm_ui_icon_raynor_split_debilitatingrounds.png": 39971,
	"./talents/raynor/storm_ui_icon_raynor_split_fuelrush.png": 20940,
	"./talents/rehgar/rehgar.png": 26151,
	"./talents/rehgar/rehgar.webp": 28324,
	"./talents/rehgar/rehgar_ancestralhealing.png": 8153,
	"./talents/rehgar/rehgar_bloodlust.png": 67374,
	"./talents/rehgar/rehgar_chainheal.png": 9127,
	"./talents/rehgar/rehgar_earthbindtotem.png": 52476,
	"./talents/rehgar/rehgar_ghostwolf.png": 8975,
	"./talents/rehgar/rehgar_lightningshield.png": 99375,
	"./talents/rehgar/rehgar_purge.png": 46275,
	"./talents/rehgar/rehgar_shamanmastertraining.webp": 82963,
	"./talents/rehgar/rehgar_spiritlink.webp": 13924,
	"./talents/rehgar/talent_healingward.png": 5165,
	"./talents/rehgar/talent_stormshield.png": 44241,
	"./talents/rexxar/rexxar_bestialwrath.png": 95982,
	"./talents/rexxar/rexxar_feigndeath.png": 34461,
	"./talents/rexxar/rexxar_flare.png": 13360,
	"./talents/rexxar/rexxar_heremishaactive.png": 73972,
	"./talents/rexxar/rexxar_mishacharge.png": 93780,
	"./talents/rexxar/rexxar_spiritswoop.png": 68637,
	"./talents/rexxar/rexxar_spiritswoop_var1.png": 93766,
	"./talents/rexxar/rexxar_stayinalive.png": 81585,
	"./talents/rexxar/rexxar_unleashtheboars.png": 23364,
	"./talents/rexxar/storm_ui_icon_rexxar_bestialwrath.png": 72027,
	"./talents/rexxar/storm_ui_icon_rexxar_feigndeath.png": 35188,
	"./talents/rexxar/storm_ui_icon_rexxar_flare.png": 32439,
	"./talents/rexxar/storm_ui_icon_rexxar_heremisha.png": 30785,
	"./talents/rexxar/storm_ui_icon_rexxar_heremishaactive.png": 24795,
	"./talents/rexxar/storm_ui_icon_rexxar_mendpet.png": 61348,
	"./talents/rexxar/storm_ui_icon_rexxar_mishacharge.png": 24103,
	"./talents/rexxar/storm_ui_icon_rexxar_mishafixate.png": 43696,
	"./talents/rexxar/storm_ui_icon_rexxar_spiritswoop.png": 12226,
	"./talents/rexxar/storm_ui_icon_rexxar_spiritswoop_var1.png": 16623,
	"./talents/rexxar/storm_ui_icon_rexxar_stampede.webp": 10909,
	"./talents/rexxar/storm_ui_icon_rexxar_stayinalive.png": 35714,
	"./talents/rexxar/storm_ui_icon_rexxar_unleashtheboars.png": 9031,
	"./talents/rexxar/storm_ui_icon_talent_burningrage.png": 71389,
	"./talents/rexxar/talent1.png": 80532,
	"./talents/rexxar/talent_autoattack_slow.png": 64783,
	"./talents/rexxar/talent_block.png": 83079,
	"./talents/rexxar/talent_burningrage.png": 10222,
	"./talents/rexxar/talent_hardenedshield.png": 32332,
	"./talents/rexxar/talent_imposingpresence.png": 28093,
	"./talents/rexxar/talent_regenerationmaster.png": 35437,
	"./talents/samuro/samuro_bladestorm.png": 21945,
	"./talents/samuro/samuro_criticalstrike.png": 27977,
	"./talents/samuro/samuro_criticalstrike_a.png": 55545,
	"./talents/samuro/samuro_criticalstrike_b.png": 99458,
	"./talents/samuro/samuro_flowingstrikes.png": 12749,
	"./talents/samuro/samuro_illusiondancer.png": 2772,
	"./talents/samuro/samuro_mirrorimage.png": 28762,
	"./talents/samuro/samuro_windwalk.png": 40809,
	"./talents/samuro/samuro_windwalk_a.png": 99737,
	"./talents/sgt-hammer/sgthammer_bluntforcegun.png": 63517,
	"./talents/sgt-hammer/sgthammer_concussiveblast.png": 10779,
	"./talents/sgt-hammer/sgthammer_hypercoolingengines.png": 37997,
	"./talents/sgt-hammer/sgthammer_napalmstrike.png": 25236,
	"./talents/sgt-hammer/sgthammer_neosteelplating.png": 46561,
	"./talents/sgt-hammer/sgthammer_siegemode.png": 28773,
	"./talents/sgt-hammer/sgthammer_siegemode_var1.png": 39566,
	"./talents/sgt-hammer/sgthammer_siegemode_var2.png": 80722,
	"./talents/sgt-hammer/sgthammer_spidermines.png": 95832,
	"./talents/sgt-hammer/talent_autoattack_damage.png": 84206,
	"./talents/sgt-hammer/talent_autoattack_searing.png": 27390,
	"./talents/sonya/sonya_ancientspear.png": 43019,
	"./talents/sonya/sonya_fury.png": 93684,
	"./talents/sonya/sonya_ignorepain.png": 34514,
	"./talents/sonya/sonya_leap.png": 59278,
	"./talents/sonya/sonya_nervesofsteel.png": 83439,
	"./talents/sonya/sonya_seismicslam.png": 3272,
	"./talents/sonya/sonya_whirlwind.png": 13412,
	"./talents/sonya/sonya_wrathoftheberserker.png": 89573,
	"./talents/sonya/talent_autoattack_cooldown.png": 65617,
	"./talents/sonya/talent_autoattack_heal.png": 12808,
	"./talents/sonya/talent_block.png": 30209,
	"./talents/sonya/talent_mercenarylord.png": 50935,
	"./talents/stitches/stitches_acidcloud.png": 59828,
	"./talents/stitches/stitches_cannibalize.png": 43694,
	"./talents/stitches/stitches_chopchop.png": 22736,
	"./talents/stitches/stitches_devour.png": 46857,
	"./talents/stitches/stitches_helpinghand.webp": 39431,
	"./talents/stitches/stitches_hook.png": 51505,
	"./talents/stitches/stitches_hungry.png": 97291,
	"./talents/stitches/stitches_patchwork.png": 94499,
	"./talents/stitches/stitches_putridbile.png": 54049,
	"./talents/stitches/stitches_slam.png": 19667,
	"./talents/stitches/stitches_underpressure.png": 38865,
	"./talents/stitches/talent_autoattack_slow.png": 67684,
	"./talents/stitches/talent_burningrage.png": 63109,
	"./talents/stukov/stukov_bio-killswitch.png": 93029,
	"./talents/stukov/stukov_flailingswipe.png": 94870,
	"./talents/stukov/stukov_healingpathogen.png": 48456,
	"./talents/stukov/stukov_healingpathogen_a.png": 82048,
	"./talents/stukov/stukov_lurkingarm.png": 54076,
	"./talents/stukov/stukov_lurkingarm_a.png": 60316,
	"./talents/stukov/stukov_massiveshove.png": 96611,
	"./talents/stukov/stukov_weightedpustule.png": 47409,
	"./talents/sylvanas/sylvanas_blackarrows.png": 16393,
	"./talents/sylvanas/sylvanas_hauntingwave.png": 60735,
	"./talents/sylvanas/sylvanas_mindcontrol.png": 69334,
	"./talents/sylvanas/sylvanas_possession.png": 76494,
	"./talents/sylvanas/sylvanas_shadowdagger.png": 7018,
	"./talents/sylvanas/sylvanas_wailingarrow.png": 88692,
	"./talents/sylvanas/sylvanas_willoftheforsaken.png": 54923,
	"./talents/sylvanas/sylvanas_witheringfire.png": 75529,
	"./talents/sylvanas/talent_boltofthestorm.png": 31329,
	"./talents/talents_bg.webp": 61742,
	"./talents/tassadar/tassadar_archon.png": 55051,
	"./talents/tassadar/tassadar_dimensionalshift.png": 90669,
	"./talents/tassadar/tassadar_forcewall.png": 41015,
	"./talents/tassadar/tassadar_oracle.png": 57762,
	"./talents/tassadar/tassadar_psionicstorm.png": 19210,
	"./talents/tassadar/tassadar_rework_active_khala.png": 7093,
	"./talents/tassadar/tassadar_rework_blackhole.png": 64250,
	"./talents/tassadar/tassadar_rework_q_ray.png": 53345,
	"./talents/tassadar/tassadar_rework_trait.png": 79801,
	"./talents/tassadar/upgrade-protoss-khaydarinamulet.png": 57139,
	"./talents/the-butcher/butcher_enraged.png": 91574,
	"./talents/the-butcher/butcher_freshmeat.png": 54129,
	"./talents/the-butcher/butcher_fullboar.png": 69573,
	"./talents/the-butcher/butcher_furnaceblast.png": 60596,
	"./talents/the-butcher/butcher_hamstring.png": 69473,
	"./talents/the-butcher/butcher_hamstring_var1.png": 11906,
	"./talents/the-butcher/butcher_lambtotheslaughter.png": 12069,
	"./talents/the-butcher/butcher_tenderize.png": 93224,
	"./talents/the-butcher/talent_autoattack_aoe.png": 23156,
	"./talents/the-butcher/talent_autoattack_slow.png": 66426,
	"./talents/the-butcher/talent_autoattack_speed.png": 41228,
	"./talents/the-butcher/talent_block.png": 41370,
	"./talents/the-butcher/talent_boltofthestorm.png": 56467,
	"./talents/the-lost-vikings/lostvikings_64kbmarathon.png": 23450,
	"./talents/the-lost-vikings/lostvikings_fastrestart.png": 92310,
	"./talents/the-lost-vikings/lostvikings_jump.png": 33809,
	"./talents/the-lost-vikings/lostvikings_longboatraid.png": 65149,
	"./talents/the-lost-vikings/lostvikings_norseforce.png": 40079,
	"./talents/the-lost-vikings/lostvikings_playagain.png": 51935,
	"./talents/the-lost-vikings/lostvikings_selectbaleog.png": 45781,
	"./talents/the-lost-vikings/lostvikings_selecterik.png": 4944,
	"./talents/the-lost-vikings/lostvikings_selecterik_var1.png": 80549,
	"./talents/the-lost-vikings/lostvikings_selectolaf.png": 37953,
	"./talents/the-lost-vikings/lostvikings_spintowin.png": 39450,
	"./talents/the-lost-vikings/lostvikings_vikinghoard.webp": 68726,
	"./talents/the-lost-vikings/talent_autoattack_cooldown.png": 61531,
	"./talents/the-lost-vikings/talent_autoattack_damage.png": 24987,
	"./talents/the-lost-vikings/talent_autoattack_searing.png": 54825,
	"./talents/the-lost-vikings/talent_bribe.png": 63414,
	"./talents/the-lost-vikings/talent_mercenarylord.png": 85681,
	"./talents/thrall/talent_autoattack_cooldown.png": 61059,
	"./talents/thrall/talent_autoattack_damage.png": 55240,
	"./talents/thrall/talent_autoattack_slow.png": 85780,
	"./talents/thrall/talent_bloodforblood.png": 17400,
	"./talents/thrall/talent_boltofthestorm.png": 8937,
	"./talents/thrall/talent_spellshield.png": 14086,
	"./talents/thrall/thrall_chainlightning.png": 8859,
	"./talents/thrall/thrall_chainlightning_var1.png": 87540,
	"./talents/thrall/thrall_chainlightning_var2.png": 9999,
	"./talents/thrall/thrall_earthquake.png": 38703,
	"./talents/thrall/thrall_feralspirit.png": 84113,
	"./talents/thrall/thrall_feralspirit_var1.png": 51570,
	"./talents/thrall/thrall_frostwolfresilience.png": 14271,
	"./talents/thrall/thrall_sundering.png": 81299,
	"./talents/thrall/thrall_windfury.png": 77278,
	"./talents/tracer/tracer_blink.png": 1436,
	"./talents/tracer/tracer_combo_e_r.png": 68723,
	"./talents/tracer/tracer_combo_q_r.png": 83727,
	"./talents/tracer/tracer_combo_q_trait.png": 8117,
	"./talents/tracer/tracer_medpack.png": 99755,
	"./talents/tracer/tracer_melee.png": 71254,
	"./talents/tracer/tracer_melee_b.png": 33577,
	"./talents/tracer/tracer_pulsebomb.png": 13089,
	"./talents/tracer/tracer_pulsebomb_b.png": 86410,
	"./talents/tracer/tracer_pulsebomb_c.png": 25267,
	"./talents/tracer/tracer_recall.png": 21287,
	"./talents/tracer/tracer_reload.png": 12147,
	"./talents/tracer/tracer_reload_b.png": 57300,
	"./talents/tracer/tracer_reload_c.png": 94781,
	"./talents/tychus/talent_autoattack_range.png": 96479,
	"./talents/tychus/talent_autoattack_searing.png": 35143,
	"./talents/tychus/talent_autoattack_speed.png": 97917,
	"./talents/tychus/talent_relentless.png": 94527,
	"./talents/tychus/tychus_commandeerodin.png": 50519,
	"./talents/tychus/tychus_drakkenlaserdrill.png": 68504,
	"./talents/tychus/tychus_drakkinlaserdrill.png": 78292,
	"./talents/tychus/tychus_fraggrenade.png": 6998,
	"./talents/tychus/tychus_minigun.png": 67049,
	"./talents/tychus/tychus_minigun_a.png": 76633,
	"./talents/tychus/tychus_overkill.png": 19244,
	"./talents/tychus/tychus_runandgun.png": 21684,
	"./talents/tychus/upgrade-terran-neosteelframe.png": 98049,
	"./talents/tyrael/talent_autoattack_cooldown.png": 92670,
	"./talents/tyrael/talent_autoattack_speed.png": 55496,
	"./talents/tyrael/talent_burningrage.png": 44367,
	"./talents/tyrael/talent_hardenedshield.png": 46475,
	"./talents/tyrael/talent_regenerationmaster.png": 70402,
	"./talents/tyrael/tyrael_archangelswrath.webp": 8385,
	"./talents/tyrael/tyrael_eldruinsmight_a.png": 71589,
	"./talents/tyrael/tyrael_eldruinsmight_b.png": 43758,
	"./talents/tyrael/tyrael_judgment.png": 33396,
	"./talents/tyrael/tyrael_righteousness.png": 29845,
	"./talents/tyrael/tyrael_righteousness_var1.png": 94942,
	"./talents/tyrael/tyrael_sanctification.png": 49773,
	"./talents/tyrael/tyrael_smite.png": 75186,
	"./talents/tyrael/tyrael_smite_a.png": 86838,
	"./talents/tyrael/tyrael_zealous_conviction.png": 56546,
	"./talents/tyrande/talent_autoattack_damage.png": 60984,
	"./talents/tyrande/talent_autoattack_heal.png": 86973,
	"./talents/tyrande/talent_autoattack_range.png": 11340,
	"./talents/tyrande/talent_autoattack_slow.png": 51428,
	"./talents/tyrande/tyrande_huntersmark.png": 45708,
	"./talents/tyrande/tyrande_lightofelune.png": 2190,
	"./talents/tyrande/tyrande_lightofelune_a.png": 97370,
	"./talents/tyrande/tyrande_lunarflare.png": 11208,
	"./talents/tyrande/tyrande_sentinel.png": 77704,
	"./talents/tyrande/tyrande_shadowstalk.png": 68879,
	"./talents/tyrande/tyrande_starfall.png": 99331,
	"./talents/tyrande/tyrande_trueshotaura.png": 2901,
	"./talents/uther/talent_autoattack_mana.png": 99089,
	"./talents/uther/talent_cleanse.png": 43007,
	"./talents/uther/talent_spellshield.png": 40153,
	"./talents/uther/uther_benediction.png": 75704,
	"./talents/uther/uther_divineshield.png": 52802,
	"./talents/uther/uther_divinestorm.png": 52542,
	"./talents/uther/uther_eternaldevotion.png": 60047,
	"./talents/uther/uther_eternaldevotion_a.png": 21779,
	"./talents/uther/uther_hammerofjustice.png": 85790,
	"./talents/uther/uther_holyfire.png": 96266,
	"./talents/uther/uther_holylight.png": 20592,
	"./talents/uther/uther_holyradiance.png": 78997,
	"./talents/valeera/talent_block.png": 6495,
	"./talents/valeera/talent_conjurerspursuit.png": 33471,
	"./talents/valeera/valeera_ambush.png": 6896,
	"./talents/valeera/valeera_bladeflurry.png": 62044,
	"./talents/valeera/valeera_cheapshot.png": 51523,
	"./talents/valeera/valeera_cloakofshadows.png": 65230,
	"./talents/valeera/valeera_cripplingpoison.png": 53534,
	"./talents/valeera/valeera_eviscerate.png": 92071,
	"./talents/valeera/valeera_garrote.png": 89048,
	"./talents/valeera/valeera_sinisterstrike.png": 63253,
	"./talents/valeera/valeera_smokebomb.png": 66725,
	"./talents/valeera/valeera_thistletea.png": 8309,
	"./talents/valeera/valeera_vanish.png": 88693,
	"./talents/valeera/valeera_woundpoison.png": 38779,
	"./talents/valla/talent_autoattack_searing.png": 14581,
	"./talents/valla/valla_hatred.png": 3624,
	"./talents/valla/valla_hatred_var1.png": 52765,
	"./talents/valla/valla_hungeringarrow.png": 65046,
	"./talents/valla/valla_multishot.png": 34045,
	"./talents/valla/valla_rainofvengeance.png": 10943,
	"./talents/valla/valla_repeatingarrow.png": 16186,
	"./talents/valla/valla_siphoningarrow.png": 67228,
	"./talents/valla/valla_strafe.png": 43041,
	"./talents/valla/valla_vault.png": 4430,
	"./talents/vanilla_icon.svg": 35285,
	"./talents/varian/varian_bannerofdalaran.png": 51914,
	"./talents/varian/varian_bannerofironforge.png": 74574,
	"./talents/varian/varian_bannerofstormwind.png": 25888,
	"./talents/varian/varian_charge.png": 35284,
	"./talents/varian/varian_colossus_smash.png": 88710,
	"./talents/varian/varian_demoralizingshout.png": 35294,
	"./talents/varian/varian_glorytothealliance.png": 91402,
	"./talents/varian/varian_heroicstrike.webp": 23015,
	"./talents/varian/varian_highkingsquest.png": 30338,
	"./talents/varian/varian_lionsfang.png": 92529,
	"./talents/varian/varian_mortalstrike.png": 33691,
	"./talents/varian/varian_parry.png": 59880,
	"./talents/varian/varian_secondwind.png": 6058,
	"./talents/varian/varian_shatteringthrow.png": 91841,
	"./talents/varian/varian_taunt.png": 61758,
	"./talents/varian/varian_twinbladesoffury.png": 74308,
	"./talents/varian/varian_victoryrush.png": 30030,
	"./talents/whitemane/whitemane_aegis.png": 59099,
	"./talents/whitemane/whitemane_clemency.webp": 94551,
	"./talents/whitemane/whitemane_desperation.png": 99158,
	"./talents/whitemane/whitemane_desperation_alt_1.png": 64398,
	"./talents/whitemane/whitemane_inquisition.png": 17408,
	"./talents/whitemane/whitemane_inquisition_lash.png": 71445,
	"./talents/whitemane/whitemane_intercession.png": 22990,
	"./talents/whitemane/whitemane_lash.png": 56024,
	"./talents/whitemane/whitemane_lash_alt_1.png": 13040,
	"./talents/whitemane/whitemane_purge.png": 4899,
	"./talents/whitemane/whitemane_reckoning.png": 7044,
	"./talents/whitemane/whitemane_zeal.png": 25904,
	"./talents/xul/necromancer_bonearmor.png": 38615,
	"./talents/xul/necromancer_bonearmor_b.png": 56912,
	"./talents/xul/necromancer_bonearmor_c.png": 63161,
	"./talents/xul/necromancer_boneprison.png": 29513,
	"./talents/xul/necromancer_bonespear.png": 76049,
	"./talents/xul/necromancer_cursedstrikes_off.png": 15541,
	"./talents/xul/necromancer_poisonnova.png": 99408,
	"./talents/xul/necromancer_raiseskeleton.png": 19645,
	"./talents/xul/necromancer_reap.png": 34078,
	"./talents/xul/necromancer_skeletalmages.png": 86206,
	"./talents/xul/rathma_dominion.png": 74601,
	"./talents/yrel/talent_abilitytalent_armor.png": 24040,
	"./talents/yrel/talent_autoattack_aoe.png": 17907,
	"./talents/yrel/talent_autoattack_heal.png": 25230,
	"./talents/yrel/yrel_ardent_defender.png": 22528,
	"./talents/yrel/yrel_avenging_wrath.png": 56210,
	"./talents/yrel/yrel_bubble_hearth.png": 29097,
	"./talents/yrel/yrel_divine_purpose.png": 99864,
	"./talents/yrel/yrel_divine_steed.png": 79295,
	"./talents/yrel/yrel_hand_of_freedom.png": 25966,
	"./talents/yrel/yrel_righteous_hammer.png": 26169,
	"./talents/yrel/yrel_sacred_ground.png": 91766,
	"./talents/yrel/yrel_seraphim.png": 13195,
	"./talents/yrel/yrel_velens_chosen.png": 37128,
	"./talents/yrel/yrel_vindication.png": 27216,
	"./talents/zagara/talent_autoattack_aoe.png": 23293,
	"./talents/zagara/talent_autoattack_damage.png": 38269,
	"./talents/zagara/talent_autoattack_range.png": 19355,
	"./talents/zagara/talent_spellshield.png": 7307,
	"./talents/zagara/zagara_banelingbarrage.png": 66804,
	"./talents/zagara/zagara_banelingbarrage_a.png": 25220,
	"./talents/zagara/zagara_creep.png": 3499,
	"./talents/zagara/zagara_devouringmaw.png": 48998,
	"./talents/zagara/zagara_hunterkiller.png": 27757,
	"./talents/zagara/zagara_hunterkillermuta.png": 45310,
	"./talents/zagara/zagara_infest.png": 72729,
	"./talents/zagara/zagara_infesteddrop.png": 87633,
	"./talents/zagara/zagara_nydusworm.png": 60676,
	"./talents/zarya/talent_autoattack_damage.png": 81384,
	"./talents/zarya/zarya_energy.png": 43104,
	"./talents/zarya/zarya_expulsionzone.png": 99461,
	"./talents/zarya/zarya_gravitonsurge.png": 69369,
	"./talents/zarya/zarya_painistemporary.png": 99099,
	"./talents/zarya/zarya_particlegrenade.png": 15842,
	"./talents/zarya/zarya_particlegrenade_a.png": 86502,
	"./talents/zarya/zarya_personalbarrier.png": 135,
	"./talents/zarya/zarya_personalbarrier_a.png": 81307,
	"./talents/zarya/zarya_pumped.png": 84769,
	"./talents/zarya/zarya_shieldally.png": 67157,
	"./talents/zarya/zarya_shieldally_a.png": 15901,
	"./talents/zarya/zarya_unyieldingdefender.png": 32197,
	"./talents/zeratul/talent_abilitytalent_damage.png": 60209,
	"./talents/zeratul/talent_abilitytalent_heal.png": 19492,
	"./talents/zeratul/talent_autoattack_damage.png": 77686,
	"./talents/zeratul/talent_autoattack_heal.png": 21767,
	"./talents/zeratul/talent_spellshield.png": 69120,
	"./talents/zeratul/zeratul_blink.png": 7588,
	"./talents/zeratul/zeratul_cleave.png": 33636,
	"./talents/zeratul/zeratul_cloak.png": 42854,
	"./talents/zeratul/zeratul_mightofnerazim.png": 10822,
	"./talents/zeratul/zeratul_shadowassault.png": 96855,
	"./talents/zeratul/zeratul_singularityspike.png": 35481,
	"./talents/zeratul/zeratul_voidprison.png": 68487,
	"./talents/zeratul/zeratul_vorpalblade.png": 87940,
	"./talents/zuljin/talent_autoattack_aoe.png": 39357,
	"./talents/zuljin/talent_autoattack_base.png": 78561,
	"./talents/zuljin/talent_autoattack_speed.png": 38041,
	"./talents/zuljin/zuljin_berzerker.png": 30060,
	"./talents/zuljin/zuljin_davoodooshuffle.png": 4946,
	"./talents/zuljin/zuljin_grievousthrow.png": 55720,
	"./talents/zuljin/zuljin_guillotine.png": 99652,
	"./talents/zuljin/zuljin_headhunter.png": 56106,
	"./talents/zuljin/zuljin_regeneration.png": 99323,
	"./talents/zuljin/zuljin_regeneration_a.png": 93287,
	"./talents/zuljin/zuljin_tazdingo.png": 80806,
	"./talents/zuljin/zuljin_trollnet.png": 79884,
	"./talents/zuljin/zuljin_twincleave.png": 25800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;